import { Component } from '@angular/core';
import { DevOpsAlarm, ErmDevOpsApiClientService } from 'erm-sdk';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-widget-sla-alarms',
  templateUrl: './sla-alarms-widget.component.html',
  styleUrls: ['./sla-alarms-widget.component.scss']
})
export class SlaAlarmsWidgetComponent {
  isLoading = false;

  redAlarms?: DevOpsAlarm[];
  greenAlarms?: DevOpsAlarm[];
  pendingAlarms?: DevOpsAlarm[];

  actions?: any[];

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService, router: Router) {
    this.actions = [
      {
        name: 'View Alarms',
        run: () => {
          const url = router.createUrlTree(['erm/alarms']);
          router.navigateByUrl(url);
        }
      }
    ];
  }

  refresh = async (): Promise<boolean> => {
    try {
      this.isLoading = true;

      const getAlarmsResponse = await this.ermDevOpsApiClient.getAlarms();
      const slaAlarms = _.filter(getAlarmsResponse.body?.alarms, x => x.serviceLevel === 'SLA');

      this.redAlarms = _.filter(slaAlarms, x => x.alarmState === 'ALARM');
      this.greenAlarms = _.filter(slaAlarms, x => x.alarmState === 'OK');
      this.pendingAlarms = _.filter(slaAlarms, x => x.alarmState === 'INSUFFICIENT_DATA');

      return true;
    }
    finally {
      this.isLoading = false;
    }
  }
}
